<div class="functii-container">
  <h1 class="functii-title">Editare funcție</h1>
  <form class="functii-card__form" [formGroup]="form" (submit)="submitForm()">
    <div class="functii-nume">
      <mat-form-field appearance="fill">
        <mat-label>Nume</mat-label>
        <input type="text" matInput formControlName="name" />
      </mat-form-field>
      <mat-error
        *ngIf="!form.controls['name'].valid && form.controls['name'].touched"
      >
        Câmp obligatoriu
      </mat-error>
    </div>
    <div class="functii-slug">
      <mat-form-field appearance="fill">
        <mat-label>Slug</mat-label>
        <input type="text" matInput formControlName="slug" />
      </mat-form-field>
      <mat-error
        *ngIf="!form.controls['slug'].valid && form.controls['slug'].touched"
      >
        Câmp obligatoriu
      </mat-error>
    </div>
    <div class="functii-observatii">
      <mat-form-field appearance="fill">
        <mat-label>Observații</mat-label>
        <input type="text" matInput formControlName="observatii" />
      </mat-form-field>
      <mat-error
        *ngIf="
          !form.controls['observatii'].valid &&
          form.controls['observatii'].touched
        "
      >
        Câmp obligatoriu
      </mat-error>
    </div>

    <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
    <div class="solicitare-action-btns">
      <button
        type="button"
        class="buttons"
        mat-flat-button
        (click)="closeDialog()"
      >
        Close
      </button>
      <button class="buttons" mat-flat-button color="primary" type="button">
        Save
      </button>
    </div>
  </form>
</div>
